(function(){
    'use strict';
    angular.module('app').controller('EmailBillingModalController', EmailBillingModalController);
    EmailBillingModalController.$inject = [
        '$uibModalInstance',
        'toastr'
    ];

    function EmailBillingModalController(
        $uibModalInstance,
        toastr
    ) {
        const vm = this;
        vm.fileTypes = [
            {name: 'CSV', value: 'csv'},
            {name: 'PDF', value: 'pdf'},
            {name: 'BOTH', value: 'csv,pdf'}
        ];
        vm.fileType = vm.fileTypes[2];
        
        vm.close = close;
        vm.proceed = proceed;

        function proceed() {
            $uibModalInstance.close(vm.fileType);
        }

        function close() {
           $uibModalInstance.close();
        }
    }
})();


// WEBPACK FOOTER //
// ./js/controllers/accounting/modals/EmailBillingModalController.js